export default __webpack_public_path__ + "static/media/signup.f37e150c.svg";